import styles from "./modal.module.scss";

import classNames from "classnames";

import { ReactComponent as CloseBtn } from "../../../assets/svg/Vector.svg";

interface Props {
  visible: boolean;
  children: any;
  onCancel: () => void;
  size?: string;
  disableMaskClose?: boolean;
  disableCloseBtn?: boolean;
  customModalContainerClassName?: string;
  customModalClassName?: string;
}

const Modal = ({
  visible,
  children,
  onCancel,
  size = "",
  disableMaskClose = false,
  disableCloseBtn = false,
  customModalContainerClassName,
  customModalClassName,
}: Props) => {
  return (
    <>
      {visible ? (
        <div
          className={classNames(
            styles.modalContainer,
            customModalContainerClassName
          )}>
          <div
            className={styles.mask}
            onClick={() => (disableMaskClose ? () => null : onCancel())}></div>
          <div
            className={classNames(
              styles.modal,
              styles[size],
              customModalClassName
            )}>
            {disableCloseBtn ? null : (
              <button className={styles.closeBtn} onClick={onCancel}>
                <CloseBtn />
              </button>
            )}
            {children}
          </div>
        </div>
      ) : null}
    </>
  );
};

export default Modal;
